// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preview-questionnaire-modal-body .question-title[data-v-781076ec],.preview-questionnaire-modal-body .questionnaire-title[data-v-781076ec]{font-weight:700;font-size:18px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
